import type { MVF, MVFProfile } from "@lib/tranche";
import type { Evaluator } from "@lib/types";
import {
  DEFAULT_FUNDER_MATCHING_BUDGET_RATIO,
  type Funder,
  type Recommender,
} from "./aggregate";
import { HOLD_AMOUNT } from "@lib/constants";

export function getHoldAtValue(value: number): MVF {
  return [
    { dollar: 0, value, placedManually: true },
    { dollar: HOLD_AMOUNT, value, placedManually: true },
    { dollar: HOLD_AMOUNT, value: 0, placedManually: true },
  ];
}

export function getDefaultMvfProfile(holdProposalId: string): MVFProfile {
  return {
    [holdProposalId]: getHoldAtValue(0.1),
  };
}

// TODO: the default tranche profile should be contained in the event, otherwise
// a users initial tranche profile will change if we update the definition of
// the default tranche profile, which would be bad
export function initEvaluator(
  evaluatorId: string,
  userId: string,
  shortname: string,
  evaluatorType: "funder",
  holdProposalId: string,
  meanRecommenderThreshold?: number,
  holdZero?: boolean,
): Funder;
export function initEvaluator(
  evaluatorId: string,
  userId: string,
  shortname: string,
  evaluatorType: "recommender",
  holdProposalId: string,
  meanRecommenderThreshold?: number,
  holdZero?: boolean,
): Recommender;
export function initEvaluator(
  evaluatorId: string,
  userId: string,
  shortname: string,
  evaluatorType: Evaluator["type"],
  holdProposalId: string,
  meanRecommenderThreshold?: number,
  holdZero?: boolean,
): Evaluator;

export function initEvaluator(
  evaluatorId: string,
  userId: string,
  shortname: string,
  evaluatorType: Evaluator["type"],
  holdProposalId: string,
  meanRecommenderThreshold?: number,
  holdZero?: boolean,
): Evaluator {
  const evaluations = {
    [holdProposalId]: {
      evaluableType: "proposal",
      state: "evaluated",
      evaluableId: holdProposalId,
      setToZero: holdZero ?? false,
      hidden: false,
    },
  } as const;

  if (evaluatorType === "recommender") {
    return {
      type: "recommender",
      status: "active",
      id: evaluatorId,
      memberId: userId,
      shortname,
      evaluations,
      mvfProfile: getDefaultMvfProfile(holdProposalId),
      matchingMvfScales: {},
      meanRecommenderThreshold,
      mvfChanges: 0,
    };
  } else {
    return {
      type: "funder",
      status: "active",
      id: evaluatorId,
      memberId: userId,
      shortname,
      scores: {},
      proposalWeights: {},
      recommenderWeights: {},
      excludedProposalIds: [],
      usesMatching: false,
      matchingBudgetRatio: DEFAULT_FUNDER_MATCHING_BUDGET_RATIO,
      incrementalEvalSteps: [],
      undoneIncrementalEvalSteps: [],
      budget: 0,
      speculationGrantSettlementBudget: null,
    };
  }
}
